import { Map } from 'immutable';
import request, { Request } from 'superagent';

interface HashTable<T> {
  [key: string]: T;
}

type Params = any;
type Resolver = (value?: unknown) => void;
type Rejecter = (reason?: any) => void;

export default class BaseData {

  static tree = Map({});
  static reqs: HashTable<Request> = {};

  static isLoading(...args: Array<string>): boolean {
    if (BaseData.tree.hasIn(args)) {
      return true;
    }
    BaseData.startLoading(...args);
    return false;
  }

  static isReallyLoading(...args: Array<string>): boolean {
    if (BaseData.tree.hasIn(args)) {
      return true;
    }
    return false;
  }

  static post(path: string, key: string | Array<string>, params?: Params, keep_open?: boolean, cancel?: boolean): Promise<unknown> {
    BaseData.resolveLoading(key, cancel);
    params = BaseData.removeNullKeys(params);
    return BaseData.postPromise(path, key, params, keep_open);
  }

  static get(path: string, key: string | Array<string>, params?: Params, keep_open?: boolean, cancel?: boolean): Promise<unknown> {
    BaseData.resolveLoading(key, cancel);
    params = BaseData.removeNullKeys(params);
    return BaseData.getPromise(path, key, params, keep_open);
  }

  static startLoading(...args: Array<string>): void {
    BaseData.tree = BaseData.tree.setIn(args, true);
  }

  static done(...args: Array<string>): void {
    BaseData.tree = BaseData.tree.deleteIn(args);
  }

  static removeNullKeys(params?: Params): Params {
    if (params) {
      Object.keys(params).forEach((key: string) => {
        params = BaseData.removeNullKey(params, key);
      });
    }
    return params ?? {};
  }

  static removeNullKey(params: Params, key: string): any {
    if (BaseData.keyIsNull(params, key)) {
      delete params[key];
    }
    return params;
  }

  static keyIsNull(params: Params, key: string): boolean {
    return params[key] === null || params[key] === undefined;
  }

  static flattenKey(key: string | Array<string>): string {
    return Array.isArray(key) ? key.join('~') : key ?? '~';
  }

  static resolveDone(key: string | Array<string>, keep_open?: boolean): void {
    if (!keep_open) {
      if (Array.isArray(key)) {
        BaseData.done(...key);
      }
      else {
        BaseData.done(key);
      }
    }
  }

  static postPromise(path: string, key: string | Array<string>, params: Params, keep_open?: boolean): Promise<unknown> {
    return new Promise((resolve, reject) => {
      BaseData.reqs[BaseData.flattenKey(key)] = request.post(path);
      BaseData.reqs[BaseData.flattenKey(key)].type('form')
        .send(BaseData.ensureParams(params))
        .set('Accept', 'application/json')
        .end((err, res) => {
          BaseData.resolveDone(key, keep_open);
          BaseData.resolveErrors(resolve, res, reject, err);
        });
    });
  }

  static getPromise(path: string, key: string | Array<string>, params: Params, keep_open?: boolean): Promise<unknown> {
    return new Promise((resolve, reject) => {
      BaseData.reqs[BaseData.flattenKey(key)] = request.get(path);
      BaseData.reqs[BaseData.flattenKey(key)].type('form')
        .query(BaseData.ensureParams(params))
        .set('Accept', 'application/json')
        .end((err, res) => {
          BaseData.resolveDone(key, keep_open);
          BaseData.resolveErrors(resolve, res, reject, err);
        });
    });
  }

  static ensureParams(params: Params): Params {
    return params ?? {};
  }

  static resolveErrors(resolve: Resolver, response: request.Response, reject: Rejecter, err: any): void {
    err ? reject(err) : resolve(response);
  }

  static resolveLoading(key: string | Array<string>, cancel?: boolean): void {
    if (key) {
      BaseData.cancelPrevious(key, cancel);
      if (Array.isArray(key)) {
        BaseData.startLoading(...key);
      }
      else {
        BaseData.startLoading(key);
      }
    }
  }

  static cancelPrevious(key: string | Array<string>, cancel?: boolean): void {
    if (cancel) {
      BaseData.reqs[BaseData.flattenKey(key)]?.abort();
    }
  }

}
